/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartplaceholder3Inputs */

const en_eventaistartplaceholder3 = /** @type {(inputs: Eventaistartplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is happening, when, and what does it cost? Or paste a link.`)
};

const de_eventaistartplaceholder3 = /** @type {(inputs: Eventaistartplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist los, wann, und was kostet es? Oder füg einen Link ein.`)
};

/**
* | output |
* | --- |
* | "What is happening, when, and what does it cost? Or paste a link." |
*
* @param {Eventaistartplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartplaceholder3 = /** @type {((inputs?: Eventaistartplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartplaceholder3(inputs)
	return de_eventaistartplaceholder3(inputs)
});
export { eventaistartplaceholder3 as "eventAiStartPlaceholder" }